module.exports = __webpack_public_path__ + "img/icon03.c21c02c2.jpg";